module.exports = __webpack_public_path__ + "static/16-d79d8a490ea6be44817056cad7861b58.png";